/** 本地登录 token 是否存在（Sa-Token 请求头 satoken） */
export function hasAuthToken(): boolean {
  return typeof window !== 'undefined' && !!localStorage.getItem('token')?.trim();
}
